import { throttle } from 'underscore';
const SCROLL_ANIMATION_TIME = 500;
export const scrollToPosition = elementSelector => {
  if (elementSelector === undefined) {
    return;
  }
  const scrollElement = document.querySelector(elementSelector);
  if (scrollElement) {
    scrollElement.setAttribute('data-scroll-to-animation-completed', false);
    scrollElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
    scrollElement.setAttribute('data-scroll-to-animation-completed', true);
  }
};
export const scrollSidePanel = (() => {
  return throttle(scrollElement => {
    if (scrollElement === '#dependent-fields-configuration' || scrollElement === '#progressive-profiling-configuration') {
      const logicTab = document.querySelector('[data-tab-id="logic"]');
      if (logicTab) {
        logicTab.click();
      } else {
        window.requestAnimationFrame(scrollSidePanel);
      }
    }
    window.requestAnimationFrame(() => {
      const element = document.querySelector(scrollElement);
      if (element) {
        scrollToPosition(scrollElement);
      }
    });
  }, SCROLL_ANIMATION_TIME, {
    trailing: false
  });
})();
export const scrollPanel = (() => {
  return throttle((panel, scrollElement) => {
    window.requestAnimationFrame(() => {
      scrollToPosition(scrollElement);
    });
  }, SCROLL_ANIMATION_TIME, {
    trailing: false
  });
})();
export const scrollMainPanel = scrollElement => scrollPanel('#form-editor-main-panel', scrollElement);